/* eslint-disable @angular-eslint/component-selector */
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, contentChild } from '@angular/core';

import { TimelineMarkerDirective } from './timeline-marker.directive';

@Component({
  selector: 'li[ui-timeline-item]',
  imports: [NgTemplateOutlet],
  template: `
    <div class="timeline-marker">
      @if (contentMarker()) {
        <ng-container *ngTemplateOutlet="contentMarker()" />
      } @else {
        <svg height="12" width="12" xmlns="http://www.w3.org/2000/svg">
          <circle r="6" cx="6" cy="6" fill="var(--sys-on-surface-variant)" />
        </svg>
      }
    </div>
    <div class="timeline-content">
      <ng-content />
    </div>
  `,
  styles: `
    :host {
      background-color: inherit;
      border-left: var(--timeline-line-width) var(--timeline-line-style) var(--timeline-line-color);
      display: flex;
      margin-left: calc(var(--timeline-marker-width) / 2);
      position: relative;
    }

    .timeline-marker {
      position: absolute;
      left: calc((var(--timeline-marker-width) / 2 + var(--timeline-line-width) / 2) * -1);
      align-self: start;
      background-color: inherit;
      width: var(--timeline-marker-width);
      text-align: center;
    }

    .timeline-content {
      flex-grow: 1;
      min-height: 3rem;
      padding-left: calc(var(--timeline-marker-width) / 2);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimelineItemComponent {
  public readonly contentMarker = contentChild(TimelineMarkerDirective, { read: TemplateRef });
}
